<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25">
        <g
            id="Layer_2"
            data-name="Layer 2">
            <g
                id="Layer_1-2"
                data-name="Layer 1">
                <g
                    id="Group_18652"
                    data-name="Group 18652">
                    <g
                        id="Group_18647"
                        data-name="Group 18647">
                        <rect
                            id="Rectangle_27249-6"
                            data-name="Rectangle 27249-6"
                            class="border-rect"
                            x="0.5"
                            y="0.5"
                            width="24"
                            height="24"
                            rx="4" />
                        <line
                            id="Line_37-6"
                            data-name="Line 37-6"
                            class="h-separator"
                            x1="0.5"
                            y1="6.84"
                            x2="24.11"
                            y2="6.84" />
                        <path
                            id="Path_5145-6"
                            data-name="Path 5145-6"
                            class="status-light"
                            d="M5.92,3.45a.86.86,0,0,1-.86.85.85.85,0,0,1-.85-.85.86.86,0,1,1,1.71,0Z" />
                        <path
                            id="Path_5146-6"
                            data-name="Path 5146-6"
                            class="status-light"
                            d="M9.8,3.45a.86.86,0,0,1-1.71,0,.86.86,0,1,1,1.71,0Z" />
                        <path
                            id="Path_5147-6"
                            data-name="Path 5147-6"
                            class="status-light"
                            d="M13.68,3.45a.85.85,0,1,1-1.7,0,.85.85,0,1,1,1.7,0Z" />
                    </g>
                    <g
                        id="Group_18651"
                        data-name="Group 18651">
                        <g
                            id="Group_18559-2"
                            data-name="Group 18559-2">
                            <ellipse
                                id="Ellipse_80-2"
                                data-name="Ellipse 80-2"
                                class="gear-fill"
                                cx="12.5"
                                cy="16.63"
                                rx="5.18"
                                ry="4.9" />
                            <path
                                id="Path_5187-2"
                                data-name="Path 5187-2"
                                class="gear-shape"
                                d="M13,11.88a.11.11,0,0,1,.1.09l.12.8a.11.11,0,0,0,.08.08,4,4,0,0,1,1.36.56h.11l.65-.48a.07.07,0,0,1,.06,0,.11.11,0,0,1,.07,0l.67.67a.1.1,0,0,1,0,.13l-.48.64a.11.11,0,0,0,0,.11,3.86,3.86,0,0,1,.58,1.37.11.11,0,0,0,.08.08l.78.12a.09.09,0,0,1,.08.1v.95a.09.09,0,0,1-.08.1l-.78.11a.11.11,0,0,0-.08.08,3.67,3.67,0,0,1-.56,1.39.11.11,0,0,0,0,.11l.46.63a.11.11,0,0,1,0,.13l-.67.67a.11.11,0,0,1-.07,0l-.06,0-.62-.46a.11.11,0,0,0-.11,0,3.92,3.92,0,0,1-1.4.58.11.11,0,0,0-.08.08l-.11.76a.09.09,0,0,1-.1.08H12a.09.09,0,0,1-.1-.08l-.12-.76a.08.08,0,0,0-.07-.08,3.92,3.92,0,0,1-1.4-.58.11.11,0,0,0-.11,0l-.62.46-.06,0a.09.09,0,0,1-.07,0l-.67-.67a.09.09,0,0,1,0-.13l.46-.63a.11.11,0,0,0,0-.11,3.86,3.86,0,0,1-.57-1.39.11.11,0,0,0-.08-.08l-.78-.11a.11.11,0,0,1-.08-.1v-.95a.11.11,0,0,1,.08-.1l.79-.12a.11.11,0,0,0,.08-.08,3.86,3.86,0,0,1,.58-1.37.11.11,0,0,0,0-.11l-.48-.64a.11.11,0,0,1,0-.13l.67-.67a.11.11,0,0,1,.07,0l.06,0,.65.48.06,0,0,0a4,4,0,0,1,1.37-.56.1.1,0,0,0,.07-.08l.12-.8a.1.1,0,0,1,.1-.08Zm0-1.09H12a1.19,1.19,0,0,0-1.18,1l0,.16-.44.18-.13-.1a1.19,1.19,0,0,0-1.55.12L8,12.84a1.19,1.19,0,0,0-.12,1.55l.1.12c-.07.15-.13.3-.19.45l-.15,0a1.18,1.18,0,0,0-1,1.18v.95a1.17,1.17,0,0,0,1,1.17l.14,0a2.72,2.72,0,0,0,.19.47l-.09.11A1.17,1.17,0,0,0,8,20.42l.67.67a1.19,1.19,0,0,0,1.55.12l.1-.07.47.2,0,.12a1.19,1.19,0,0,0,1.18,1h1a1.18,1.18,0,0,0,1.17-1l0-.12.48-.2.1.07a1.19,1.19,0,0,0,1.54-.11l.67-.68a1.17,1.17,0,0,0,.12-1.54L17,18.77c.07-.15.13-.31.19-.47l.14,0a1.18,1.18,0,0,0,1-1.17v-.95a1.19,1.19,0,0,0-1-1.18l-.16,0a4.22,4.22,0,0,0-.18-.45l.09-.12A1.19,1.19,0,0,0,17,12.84l-.67-.67a1.19,1.19,0,0,0-1.54-.12l-.14.1L14.18,12l0-.17a1.18,1.18,0,0,0-1.17-1" />
                            <circle
                                id="Ellipse_81-2"
                                data-name="Ellipse 81-2"
                                class="gear-hole-fill"
                                cx="12.5"
                                cy="16.63"
                                r="1.77" />
                            <circle
                                id="Ellipse_82-2"
                                data-name="Ellipse 82-2"
                                class="gear-hole-shape"
                                cx="12.5"
                                cy="16.63"
                                r="1.77" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<style>
    .border-rect,
    .status-light,
    .gear-hole-fill {
        fill: #ffffff;
        stroke: var(--bs-primary-600);
    }
    .border-rect,
    .status-light,
    .h-separator {
        stroke: var(--bs-primary-700);
    }
    .border-rect,
    .status-light,
    .h-separator,
    .gear-hole-shape {
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    .h-separator,
    .gear-hole-shape {
        fill: none;
    }
    .gear-fill {
        fill: var(--bs-primary-200);
    }
    .gear-shape {
        fill: var(--bs-primary-600);
    }
    .gear-hole-shape {
        stroke: var(--bs-primary-600);
    }
</style>
